import { render, staticRenderFns } from "./CompanyObjectSidebar.vue?vue&type=template&id=25a79b84&scoped=true"
import script from "./CompanyObjectSidebar.vue?vue&type=script&lang=js"
export * from "./CompanyObjectSidebar.vue?vue&type=script&lang=js"
import style0 from "./CompanyObjectSidebar.vue?vue&type=style&index=0&id=25a79b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a79b84",
  null
  
)

export default component.exports